import { LIVE_PARTICIPANTS_REQUEST, LIVE_PARTICIPANTS_COMPLETE, LIVE_PARTICIPANTS_ERR, LIVE_PARTICIPANT_ADDRESSED_UPDATE_REQUEST, LIVE_PARTICIPANT_ADDRESSED_UDPATE_COMPLETE, LIVE_PARTICIPANT_ADDRESSED_UDPATE_ERR, SYNC_ZOOM_PARTICIPANTS_REQUEST, SYNC_ZOOM_PARTICIPANTS_COMPLETE, SYNC_ZOOM_PARTICIPANTS_ERR, WATCHLIST_WEBSOCKET_DISCONNECTED, LIVE_PARTICIPANTS_RESET_ADDRESSED_REQUEST, LIVE_PARTICIPANTS_RESET_ADDRESSED_COMPLETE, LIVE_PARTICIPANTS_RESET_ADDRESSED_ERR } from '../actions/actionTypes';
import initialState from './initialState';
import stateConfig from '../config/state';

const status = stateConfig.responseStatus;

function liveParticipantsReducer(state = initialState.liveParticipants, action) {
  switch (action.type) {
    case LIVE_PARTICIPANTS_REQUEST:
      return state;
    case LIVE_PARTICIPANTS_COMPLETE:
      return { ...state, responseStatus: status.COMPLETE, responseErr: null, participants: action.data };
    case LIVE_PARTICIPANTS_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case LIVE_PARTICIPANT_ADDRESSED_UPDATE_REQUEST:
      return { ...state, responseStatus: status.DEFAULT, responseErr: null };
    case LIVE_PARTICIPANT_ADDRESSED_UDPATE_COMPLETE:
      return {
        ...state,
        responseStatus: status.COMPLETE,
        participants: state.participants.map((p) => p._id === action.memberId ? { ...p, addressed: action.addressed } : p)
      };
    case LIVE_PARTICIPANT_ADDRESSED_UDPATE_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case SYNC_ZOOM_PARTICIPANTS_REQUEST:
      return { ...state, responseStatus: status.DEFAULT, responseErr: null };
    case SYNC_ZOOM_PARTICIPANTS_COMPLETE:
      return {
        ...state,
        responseStatus: status.COMPLETE,
        responseErr: null,
        participants: action.data
      };
    case SYNC_ZOOM_PARTICIPANTS_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case LIVE_PARTICIPANTS_RESET_ADDRESSED_REQUEST:
      return { ...state, responseErr: null };
    case LIVE_PARTICIPANTS_RESET_ADDRESSED_COMPLETE:
      return { ...state, responseStatus: status.COMPLETE, participants: state.participants.map((p) => ({ ...p, addressed: false }))};
    case LIVE_PARTICIPANTS_RESET_ADDRESSED_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case WATCHLIST_WEBSOCKET_DISCONNECTED:
      return { ...state, participants: []};
    default:
      return state;
  }
}

export default liveParticipantsReducer;